



































































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { TaskPriority } from 'admiral-core';

@Component({
  name: 'TaskPriorityIcon',
})
export default class TaskPriorityIcon extends Vue {
  @Prop({ type: String, required: true }) priority!: TaskPriority;
  @Prop({ type: String, default: 'md' }) size!: 'sm' | 'md' | 'lg';

  get sizeClass(): string {
    const map = { sm: 'size-sm', md: 'size-md', lg: 'size-lg' };
    return map[this.size] || 'size-md';
  }
}
